module.exports = __webpack_public_path__ + "img/cancel.cb7640d6.svg";